import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Space: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1' }]],
];

export default Space;
